import { Injectable } from '@angular/core'
import { ComponentStore } from '@ngrx/component-store'

import type * as models from './models'

export interface AtnDsPageHeaderState {
  breadcrumbs: models.Breadcrumb[] | undefined
  currentPage: number | undefined
  name: string | undefined
  totalPages: number | undefined
  loading: boolean | undefined
}
export namespace AtnDsPageHeaderState {
  export const INITIAL: Required<AtnDsPageHeaderState> = {
    breadcrumbs: undefined,
    currentPage: undefined,
    loading: undefined,
    name: undefined,
    totalPages: undefined,
  }
}

@Injectable()
export class AtnDsPageHeaderStore extends ComponentStore<AtnDsPageHeaderState> {
  /** {@link AtnDsPageHeaderState.name} */
  public readonly nameSg = this.selectSignal(state => state.name)
  /** {@link AtnDsPageHeaderState.loading} */
  public readonly loadingSg = this.selectSignal(state => state.loading)
  /** {@link AtnDsPageHeaderState.breadcrumbs} */
  public readonly breadcrumbsSg = this.selectSignal(state => state.breadcrumbs)
  /**
   * Indicates whether breadcrumbs are present based on their existence and
   * length
   */
  public presentBreadcrumbsSg = this.selectSignal(
    state => state.breadcrumbs !== undefined && state.breadcrumbs.length > 0,
  )

  constructor() {
    super(AtnDsPageHeaderState.INITIAL)
  }
}
